var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2133 23.5H6.21335C5.66185 23.5 5.21335 23.0515 5.21335 22.5V11.5C5.21335 10.9485 5.66185 10.5 6.21335 10.5H26.2133C26.7648 10.5 27.2133 10.9485 27.2133 11.5V22.5C27.2133 23.0515 26.7648 23.5 26.2133 23.5ZM6.21335 11.5V22.5H26.2133V11.5H6.21335Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21335 6.5H7.21335V7.5H5.21335V6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21335 6.5H10.2133V7.5H8.21335V6.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2133 6.5H13.2133V7.5H11.2133V6.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7133 4.5H4.71335C3.88635 4.5 3.21335 5.173 3.21335 6V24C3.21335 24.827 3.88635 25.5 4.71335 25.5H27.7133C28.5403 25.5 29.2133 24.827 29.2133 24V6C29.2133 5.173 28.5403 4.5 27.7133 4.5ZM28.2133 6V8.5H25.2133V5.5H27.7133C27.9893 5.5 28.2133 5.724 28.2133 6ZM4.71335 5.5H24.2133V8.5H4.21335V6C4.21335 5.724 4.43735 5.5 4.71335 5.5ZM27.7133 24.5H4.71335C4.43735 24.5 4.21335 24.276 4.21335 24V9.5H28.2133V24C28.2133 24.276 27.9893 24.5 27.7133 24.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21335 26.5H28.2133V27.5H4.21335V26.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5668 13.6465L10.8598 14.3535L13.5068 16.9995L10.8598 19.6465L11.5668 20.3535L14.2138 17.7065C14.6033 17.317 14.6033 16.6835 14.2138 16.294L11.5668 13.6465Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2133 19H21.2133V20H16.2133V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.815ae18d.svg";
export { ForwardRef as ReactComponent };